import { render, staticRenderFns } from "./AddClue.vue?vue&type=template&id=a16e6a76"
import script from "./AddClue.vue?vue&type=script&lang=js"
export * from "./AddClue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports